import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFlagComponent } from "./med-icon-flag.component";

@NgModule({
  declarations: [
    MedIconFlagComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFlagComponent,
  ],
})
export class MedIconFlagModule { }
